import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import {
    DesktopLogo,
    MobileLogo,
    NavLogo,
} from '../../components/Navigation/Style';

const Logo = () => {
    const { themeMode } = useTheme();
    const { i18n } = useTranslation();
    const logoImage =
        themeMode === 'light'
            ? `${process.env.PUBLIC_URL || ''}/img/black_logo.png`
            : `${process.env.PUBLIC_URL || ''}/img/white_logo.png`;

    const language = i18n.language || 'en';
    const baseUrl = process.env.PUBLIC_URL || '';
    const homeUrl = `${baseUrl}/${language}/`;

    return (
        <NavLogo href={homeUrl}>
            <DesktopLogo>
                <img src={logoImage} alt="Logo" />
            </DesktopLogo>
            <MobileLogo>
                <img src={logoImage} alt="Logo" />
            </MobileLogo>
        </NavLogo>
    );
};

export default Logo;
